export default __webpack_public_path__ + "static/media/CUSTOM_DOLLOR_TINY.016b7232.svg";